import React from 'react'
import axios from 'axios'
import { Grid, Typography, Tabs, Tab, Paper, Button, Card, Rating } from '@mui/material'
import { useParams } from 'react-router-dom'
import { ChatBubble } from '@mui/icons-material'
import useStyles from './styles'
import ReasonList from './list'
import Comment from './comment'
import { CUSTOMER_SURVEY_ADD_BY_LINK } from '../../../constants/api'

function InfoRating(props) {
    const classes = useStyles()
    const clickRating = (e, v) => props.setScore(v)

    const tabFunc = (event, newValue) => props.setRatingTab(newValue)
    let { token } = useParams()
    token = token.replace('token=', '')

    const getRatingScoreTitle = (score) => {
        switch (score) {
            case 0:
                return "خیلی بد"
            case 1:
                return "خیلی بد"
            case 2:
                return "بد"
            case 3:
                return "معمولی"
            case 4:
                return "خوب"
            case 5:
                return "عالی"
            default:
                return "خیلی بد"
        }
    }

    const rating = async () => {
        let body = {
            vRequestCode: props.receipt.vRequestCode,
            iDriverScore: props.score,
            vCustomerComment: props.comment,
            vReasonSatisfactionTitle: props.reasonRating,
            vToken: token
        }
        try {
            let url = process.env.REACT_APP_API_URL + CUSTOMER_SURVEY_ADD_BY_LINK
            let response = await axios.post(url, body)
            let data = response.data
            if (data.settings.success === 1) {
                props.setIsRating(1)
            }
        } catch (error) {
        }
    }

    return (
        <React.Fragment>
            <Grid className={classes.title}>
                <Typography variant="h1">
                    به درخواست امتیاز دهید
                </Typography>
            </Grid>
            <Grid className={classes.gridRating}>
                <Rating
                    style={{
                        fontSize: 50,
                        direction: 'rtl',
                        marginBottom: 20,
                        marginTop: 20
                    }}
                    name="rating"
                    size="large"
                    value={props.score}
                    className={classes.rating}
                    defaultValue={props.score}
                    onChange={(e, v) => clickRating(e, v)}
                />
            </Grid>
            <Grid className={classes.gridRatingTitle}>
                <Typography variant="h5" className={props.score >= 3 ? classes.ratingTitleGood : classes.ratingTitleBad}>
                    {getRatingScoreTitle(props.score)}
                </Typography>
            </Grid>
            <Paper>
                <Tabs
                    value={props.ratingTab}
                    onChange={tabFunc}
                    indicatorColor={props.ratingTab === 0 ? "primary" : "secondary"}
                    centered
                    variant="fullWidth"
                >
                    <Tab
                        label={"نقاط قوت"}
                        className={props.ratingTab === 0 ? classes.tabStrength : ''}
                    />
                    <Tab
                        label={"نقاط ضعف"}
                        className={props.ratingTab === 1 ? classes.tabWeakPoint : ''}
                    />
                </Tabs>
            </Paper>
            <ReasonList {...props} />
            <Comment {...props} />
            <Card className={classes.cardBottom}>
                <Grid container spacing={2}>
                    <Grid item xs={8} md={8}>
                        <Button onClick={() => rating()} variant="contained" color="primary" fullWidth>
                            ثبت بازخورد
                        </Button>
                    </Grid>
                    <Grid item xs={4} md={4}>
                        <Button
                            onClick={() => props.setIsComment(true)}
                            startIcon={<ChatBubble />} variant="text" color="secondary" fullWidth>
                            ثبت نظر
                        </Button>
                    </Grid>
                </Grid>
            </Card>
        </React.Fragment>
    )
}

export default InfoRating

